if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add('sticky-atc-bar-enabled');

        this.selectors = {
          variantIdInput: '[data-current-variant-id]',
        };
      }

      get optionSelects() {
        return this.querySelectorAll('[data-option-position]');
      }

      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }

      get variantIdInput() {
        return this.querySelector(this.selectors.variantIdInput);
      }

      initCustomSelects() {
        this.customSelects = this.querySelectorAll('.custom-select');
      
        this.customSelects.forEach(select => {
          const trigger = select.querySelector('.custom-select__trigger');
          const dropdown = select.querySelector('.custom-select__dropdown');
          const valueSpan = select.querySelector('.custom-select__value');
      
          trigger.addEventListener('click', (e) => {
            e.stopPropagation();           
            document.querySelectorAll('.custom-select.open').forEach(s => {
              if (s !== select) s.classList.remove('open');
            });
      
            select.classList.toggle('open');
          });      

          dropdown.querySelectorAll('.custom-select__option').forEach(option => {
            option.addEventListener('click', () => {
              const newValue = option.dataset.value;
              
              valueSpan.textContent = newValue;
              option.parentElement.querySelectorAll('.custom-select__option').forEach(opt => {
                opt.classList.toggle('selected', opt === option);
              });
      
              select.classList.remove('open');                          
              select.dataset.value = newValue;     
              this.onOptionChange();
            });
          });
        });      

        document.addEventListener('click', () => {
          this.customSelects.forEach(s => s.classList.remove('open'));
        });
      }

      connectedCallback() {
        this.productFormActions = document.querySelector(`.main-product-form[data-product-id="${this.productId}"]`);
        this.mainProductInfo = document.querySelector(`product-info[data-product-id="${this.productId}"]`);
        this.container = this.closest('.sticky-atc-bar');
        this.submitButton = this.querySelector('[type="submit"]');
        this.variantData = this.getVariantData();
        this.init();
        this.initCustomSelects();        
        this.syncWithMainProductForm();         
      }

      get productId() {
        return this.getAttribute('data-product-id');
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      getVariantData() {
        if (this.variantData && this.variantData.length > 0) {
          return this.variantData;
        }     
        let script = this.querySelector('script[type="application/json"]');      
        if (!script) {
          script = document.querySelector('.sticky-atc-bar script[type="application/json"]');
        }
      
        if (script) {
          try {
            this.variantData = JSON.parse(script.textContent);            
          } catch (e) {            
            this.variantData = [];
          }
        } else {
          console.error('❌ No variant JSON script found in sticky-atc-bar!');
        }      
        return this.variantData || [];
      }

      bindVariantSelectors() {
        if (!this.optionSelects.length) return;

        this.optionSelects.forEach((select) => {
          select.addEventListener('change', () => {
            if (this.isUpdating) return;
            this.isUpdating = true;

            this.onOptionChange();
            this.syncToMainForm();

            setTimeout(() => {
              this.isUpdating = false;
            }, 50);
          });
        });
      }

      onOptionChange() {
        const selectedOptions = Array.from(this.customSelects).map(select => {
          const valueSpan = select.querySelector('.custom-select__value');
          return valueSpan ? valueSpan.textContent.trim() : '';
        });
      
        
        const matchedVariant = this.variantData.find(variant =>
          variant.options.every((option, i) => (option || '').trim() === selectedOptions[i])
        );
          
        if (matchedVariant) {
          if (this.variantIdInput) this.variantIdInput.value = matchedVariant.id;        
          this.currentVariant = matchedVariant;        
          this.updateQuantityInput();
          this.updatePrice();
          this.updateButton(!matchedVariant.available, FoxTheme.variantStrings.soldOut);          
          setTimeout(() => this.syncToMainForm(), 20);
        }             
      }

      syncToMainForm() {
        if (!this.mainProductInfo) return;
        const mainVariantSelects = this.mainProductInfo.querySelector('variant-selects');
        if (!mainVariantSelects) return;

        const selectedOptions = Array.from(this.customSelects).map(select => {
          const valueSpan = select.querySelector('.custom-select__value');
          return valueSpan ? valueSpan.textContent.trim() : '';
        });
        this.isUpdating = true; 

        Array.from(mainVariantSelects.querySelectorAll('select, fieldset')).forEach((element, index) => {
          const value = selectedOptions[index];
          if (!value) return;

          if (element.tagName === 'SELECT') {
            if (element.value !== value) {
              element.value = value;              
              element.dispatchEvent(new Event('change', { bubbles: true }));
            }
          } else if (element.tagName === 'FIELDSET') {
            const radio = element.querySelector(`input[type="radio"][value="${CSS.escape(value)}"]`);
            if (radio && !radio.checked) {
              radio.checked = true;              
              radio.click(); 
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        });

        const mainIdInput = mainVariantSelects.querySelector('input[name="id"]') || 
                           this.mainProductInfo.querySelector('input[name="id"]');

        if (mainIdInput && this.currentVariant) {
          mainIdInput.value = this.currentVariant.id;
        }

        setTimeout(() => {
          const event = new CustomEvent('change', { 
            bubbles: true, 
            detail: { fromSticky: true, force: true, source: 'sticky-atc' } 
          });

          mainVariantSelects.dispatchEvent(event);

          if (mainIdInput) {
            mainIdInput.dispatchEvent(new Event('input', { bubbles: true }));
            mainIdInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          this.mainProductInfo.dispatchEvent(new Event('variant:change', { bubbles: true }))
          this.isUpdating = false;          
        }, 50);
      }

      updateQuantityInput() {
        if (!this.currentVariant) return;

        fetch(`${this.getAttribute('data-url')}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`)
          .then(res => res.text())
          .then(html => {
            const temp = new DOMParser().parseFromString(html, 'text/html');
            const newQuantityHTML = temp.querySelector(`#QuantitySticky-${this.sectionId}`);

            if (newQuantityHTML) {
              const currentQuantityContainer = document.querySelector(`#QuantitySticky-${this.sectionId}`);
              if (currentQuantityContainer) {
                currentQuantityContainer.innerHTML = newQuantityHTML.innerHTML;
              }
            }
          })
          .catch(console.error);
      }

      updatePrice() {
        const classes = {
          onSale: 'f-price--on-sale',
          soldOut: 'f-price--sold-out',
        };
        const selectors = {
          priceWrapper: '.f-price',
          salePrice: '.f-price-item--sale',
          compareAtPrice: ['.f-price-item--regular'],
          unitPriceWrapper: '.f-price__unit-wrapper',
        };
        const moneyFormat = FoxTheme.settings.moneyFormat;
        const { priceWrapper, salePrice, unitPriceWrapper, compareAtPrice } = FoxTheme.utils.queryDomNodes(
          selectors,
          this
        );
        const unitPrice = unitPriceWrapper.querySelector('.f-price__unit');

        const { compare_at_price, price, unit_price_measurement } = this.currentVariant;

        // On sale.
        if (compare_at_price && compare_at_price > price) {
          priceWrapper.classList.add(classes.onSale);
        } else {
          priceWrapper.classList.remove(classes.onSale);
        }

        // Sold out.
        if (!this.currentVariant.available) {
          priceWrapper.classList.add(classes.soldOut);
        } else {
          priceWrapper.classList.remove(classes.soldOut);
        }

        if (salePrice) salePrice.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat);

        if (compareAtPrice && compareAtPrice.length && compare_at_price > price) {
          compareAtPrice.forEach(
            (item) => (item.innerHTML = FoxTheme.Currency.formatMoney(compare_at_price, moneyFormat))
          );
        } else {
          compareAtPrice.forEach((item) => (item.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat)));
        }

        if (unit_price_measurement && unitPrice) {
          unitPriceWrapper.classList.remove('hidden');
          const unitPriceContent = `<span>${FoxTheme.Currency.formatMoney(
            this.currentVariant.unit_price,
            moneyFormat
          )}</span>/<span data-unit-price-base-unit>${FoxTheme.Currency.getBaseUnit(this.currentVariant)}</span>`;
          unitPrice.innerHTML = unitPriceContent;
        } else {
          unitPriceWrapper.classList.add('hidden');
        }
      }

      updateButton(disable = false, text = '') {
        const addButton = this.querySelector('[name="add"]');
        if (!addButton) return;

        const btnText = addButton.querySelector('span');

        if (disable) {
          addButton.disabled = true;
          if (text) btnText.textContent = text;
        } else {
          addButton.disabled = false;
          btnText.textContent = FoxTheme.variantStrings.addToCart;
        }
      }

      syncFromMainToSticky(externalVariant = null) {
        let variant = externalVariant;
      
        if (!variant) {          
          const selectedVariantScript = this.mainProductInfo.querySelector('script[data-selected-variant]');
          if (selectedVariantScript) {
            try {
              variant = JSON.parse(selectedVariantScript.textContent);
            } catch (e) {}
          }
        }
      
        if (!variant) return;
      
        this.currentVariant = variant;
        if (this.customSelects && this.customSelects.length) {
          variant.options.forEach((optionValue, index) => {
            const select = this.customSelects[index];
            if (!select) return;
      
            const valueSpan = select.querySelector('.custom-select__value');
            if (valueSpan) valueSpan.textContent = optionValue;
            select.querySelectorAll('.custom-select__option').forEach(opt => {
              opt.classList.toggle('selected', opt.dataset.value === optionValue);
            });
          });
        }

        if (this.variantIdInput) {
          this.variantIdInput.value = variant.id;
        }
      
        this.updatePrice();
        this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut);
        this.updateQuantityInput();      
      }

      syncWithMainProductForm() {
        if (!this.mainProductInfo) return;
        const mainVariantSelects = this.mainProductInfo.querySelector('variant-selects');
        if (!mainVariantSelects) return;        

        mainVariantSelects.addEventListener('change', (e) => {                    
          if (this.isUpdating || (e.detail && (e.detail.fromSticky || e.detail.source === 'sticky-atc'))) {
            return;
          }          
          this.syncFromMainToSticky();
        });
       
        if (FoxTheme?.pubsub) {
          FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
            if (this.isUpdating) return; 
            if (event.data.sectionId === this.mainProductInfo.dataset.section) {
              this.syncFromMainToSticky(event.data.variant);
            }
          });
        }
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add('sticky-atc-bar--show');
          return;
        }

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = () => this.checkDevice();
        this.checkDevice();

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach(entry => {
              this.container.classList.toggle('sticky-atc-bar--show', entry.intersectionRatio < 1);
            });
          },
          { threshold: 1, rootMargin: '-80px 0px 0px 0px' }
        );

        observer.observe(this.productFormActions);
      }

      checkDevice() {
        document.documentElement.style.setProperty('--sticky-atc-bar-height', this.clientHeight + 'px');
      }
    }
  );
}
